module.exports = "<div class=\"pp-screen pp-device-orientation-warning\" data-bind=\"visible: visible\">\r\n\r\n    <div class=\"pp-screen__background pp-instructions__background\"></div>\r\n\r\n    <div class=\"pp-screen__foreground\">\r\n\r\n        <div class=\"logo main-menu__logo\">\r\n            <img class=\"pp-main-menu__edu-logo__image\" src=\"assets/images/intro/logo.png\"/>\r\n        </div>\r\n\r\n        <h2>Turn your device to play</h2>\r\n\r\n    </div>\r\n\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/ts/screens/device-orientation-warning/OrientationWarningScreen.html
// module id = 64
// module chunks = 0